import Model from '../orm/Model'

export default class ScanCode extends Model {

    static entity = 'scan_code'

    static fields() {
        return {
            type: this.attr(null),
            code: this.attr(null)
        }
    }

    static graphql = {
        one: {
            type: 'scanCode',
            parameters: {
                uuid: 'String!',
                type: 'String'
            }
        }
    }
}